var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnNavHistoryActive = function SvgEarnNavHistoryActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.727.975H2.064C1.2.975.5 1.675.5 2.539v16.597C.5 20 1.2 20.7 2.064 20.7h14.663c.863 0 1.564-.7 1.564-1.564V2.539c0-.864-.7-1.564-1.564-1.564Z",
    fill: "#305992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.188 6.817h-9.59v.85h9.59v-.85ZM14.188 9.216h-9.59v.85h9.59v-.85ZM14.188 11.61h-9.59v.85h9.59v-.85ZM10.595 14.008H4.598v.85h5.997v-.85Z",
    fill: "#4376B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.078 24.553a1.395 1.395 0 0 1-2 0l-4.227-4.228a1.394 1.394 0 0 1 1.521-2.277c.17.07.323.173.453.303l4.228 4.228a1.396 1.396 0 0 1 .025 1.974Z",
    fill: "#6794C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.624 18.676a5.408 5.408 0 0 1 0-8.57 5.423 5.423 0 0 1 6.582 0 5.412 5.412 0 0 1 0 8.575 5.412 5.412 0 0 1-6.582-.005Z",
    fill: "#CAD9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.717 9.795H7.312l1.964-.85h6.441v.85ZM15.722 11.345h-8.41v.85h8.41v-.85ZM15.722 13.743h-8.41v.85h8.41v-.85ZM12.569 16.142H7.312v.85h5.257v-.85Z",
    fill: "#305992"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.053 22.554 21.87 20.37a2.948 2.948 0 0 1-.7-3.138 7.79 7.79 0 0 0-1.629-8.236 7.856 7.856 0 0 0-10.824-.41 7.806 7.806 0 0 0-.31 11.32 7.807 7.807 0 0 0 8.34 1.743 2.999 2.999 0 0 1 3.17.715l2.188 2.189a1.393 1.393 0 0 0 2.159-.225 1.42 1.42 0 0 0-.21-1.774Zm-13.428-3.878a5.408 5.408 0 0 1 0-8.57 5.422 5.422 0 0 1 6.582 0 5.413 5.413 0 0 1 0 8.575 5.412 5.412 0 0 1-6.582-.005Z",
    fill: "#6794C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m22.754 21.255-2 1.998 1.325 1.325a1.393 1.393 0 0 0 2 0 1.393 1.393 0 0 0 0-2l-1.325-1.323Z",
    fill: "#305992"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m22.747 21.253-1.972 1.971.598.598 1.971-1.972-.597-.597Z",
    fill: "#274673"
  })));
};
export default SvgEarnNavHistoryActive;